import { Config } from '@ecdlink/core';
import { api } from '../axios.helper';
import { UserHelp, MutationSaveUserHelpArgs } from '@ecdlink/graphql';

class UserHelpService {
  _accessToken: string | null;

  constructor(accessToken: string | null) {
    this._accessToken = accessToken;
  }

  async saveUserHelp(input: MutationSaveUserHelpArgs): Promise<UserHelp> {
    const apiInstance = api(Config.graphQlApi, this._accessToken!);
    const response = await apiInstance.post<{
      data: { saveUserHelp: UserHelp };
      errors?: {};
    }>(``, {
      id: 'saveUserHelp',
      variables: {
        userHelp: input.userHelp,
        screenshotBase64String: input.screenshotBase64String,
      },
    });
    return response.data.data.saveUserHelp;
  }
}

export default UserHelpService;
